var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"l-header"},[_c('app-header-bar'),_c('app-header-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }